import { render, staticRenderFns } from "./ThirdPartySabaBetContent.vue?vue&type=template&id=43045897"
import script from "./ThirdPartySabaBetContent.vue?vue&type=script&lang=js"
export * from "./ThirdPartySabaBetContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports